module.exports = __webpack_public_path__ + "img/08.271989b6.jpg";